import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const McqPage = lazy(() => import('src/pages/dashboard/assignment/mcq'));
const PhysicsSyllabusPage = lazy(() => import('src/pages/dashboard/syllabus/physics/all'));

const StaffPage = lazy(() => import('src/pages/dashboard/users/staff/all'));

const AnnouncementPage = lazy(() => import('src/pages/dashboard/site/announcement'));

const AccountPage = lazy(() => import('src/pages/dashboard/profile/account'));
const PageProfileSecurity = lazy(() => import('src/pages/dashboard/profile/security'));
// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'assignment',
        children: [
          { element: <McqPage />, index: true },
          { path: 'mcq', element: <McqPage /> }
        ],
      },
      {
        path: 'syllabus',
        children: [
          { element: <PhysicsSyllabusPage />, index: true },
          { path: 'physics', element: <PhysicsSyllabusPage /> }
        ],
      },
      {
        path: 'user',
        children: [
          { element: <StaffPage />, index: true },
          { path: 'staff', element: <StaffPage /> }
        ],
      },
      {
        path: 'site',
        children: [
          { element: <AnnouncementPage />, index: true },
          { path: 'announcement', element: <AnnouncementPage /> }
        ],
      },
      {
        path: 'profile',
        children: [
          { element: <AccountPage />, index: true },
          { path: 'account', element: <AccountPage /> },
          { path: 'security', element: <PageProfileSecurity /> }
        ],
      }
    ]
  }
];